import { PrismaClient } from '@prisma/client';
import LoginForm from '../Client/Components/Auth/LoginForm';
import AuthSidebar from '../Client/Components/Auth/AuthSidebar';
import Demo from '../Client/Components/Demo';
import Layout from '../Client/Components/Layout';
import { useSelector } from 'react-redux';
import { useEffect } from 'react';
import { useRouter } from 'next/router';
import ForgotPassword from '../Client/Components/Auth/ForgotPassword';
import SEO from '../Client/Components/SEO';

function Login(props) {
  // const { email } = props.user;

  return (
    <div>
      <SEO
        title="Forgot Password"
        desc="Forgot Password | 1LinsApp is a free and elegant link-in-bio tool for creators. Claim your name in less than a minute!"
      />
      <ForgotPassword />
    </div>
  );
}

Login.getLayout = function getLayout(page) {
  return <AuthSidebar>{page}</AuthSidebar>;
};

export default Login;
